import React from 'react';

import { Button, ButtonGroup } from '@mui/material';

interface ListGroupProps {
  items: any[];
  selectedItem: any;
  valueProperty?: string;
  textProperty?: string;
  onItemSelect: (item: any) => void;
}

const ListGroup: React.FunctionComponent<ListGroupProps> = ({
  items,
  selectedItem,
  valueProperty = 'id',
  textProperty = 'name',
  onItemSelect,
}) => {
  return (
    <ButtonGroup
      variant='outlined'
      aria-label='outlined button group'
      sx={styles.buttonGroup}
    >
      {items.map((item) => (
        <Button
          variant={item.id === selectedItem.id ? 'contained' : 'outlined'}
          onClick={() => onItemSelect(item)}
          key={item[valueProperty]}
          sx={styles.button}
        >
          {item[textProperty]}
        </Button>
      ))}
    </ButtonGroup>
  );
};

const styles = {
  buttonGroup: { mx: 2, mb: 2 },
  button: { px: { xs: 0.6, sm: 2 } },
};

export default ListGroup;
